const FooterOverlay = () => (
  <div className="footerOverlay">
    <div className="footerOverlay__black" />
    <div className="footerOverlay__img app__bg" />
  </div>
);

export default FooterOverlay;
